"use client";

import { useTheme } from "next-themes";
import { Toaster } from "sonner";

export default function ThemeAwareToaster() {
    const { resolvedTheme } = useTheme();

    return (
        <Toaster
            closeButton
            richColors
            position="top-right"
            theme={resolvedTheme === "dark" ? "dark" : "light"}
        />
    );
}
